export default "__VITE_PUBLIC_ASSET__1cd7e12f__"